module.exports = __webpack_public_path__ + "static/img/base-con-img.90202aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/base-con-img.png
// module id = 8FwX
// module chunks = 0